export default __webpack_public_path__ + "static/media/logo_quero_uma_agencia.077ce0db.png";